import React from 'react'

import { CheckMark } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { SizeChart } from '../../../../components/pages/products/ProductPage/DetailsSection/SizesSection/SizeChart'
import { trackEvent } from '../../../../lib/analytics'

import { SizeChartModalTable } from './SizeChartModalTable'
import {
  CloseButton,
  Content,
  Header,
  HeaderText,
  HowToMeasureText,
  ResponsiveImage,
  Table,
  TableWrapper,
  Td,
  Th,
  TipCheckMark,
  TipItem,
  TipsSection,
  TipsSectionContent,
  TipsSectionTextBlock,
  Tr,
  WantToKnowText,
} from './styles'

export const SizeChartModalContent: React.FC<{
  onClose?: () => void
  showHeader?: boolean
  sizeChart?: SizeChart
  initialActiveTab?: number
}> = ({ onClose, showHeader = true, sizeChart, initialActiveTab }) => {
  const {
    sizesSection: {
      sizeChart: { headline, wantToKnowLine1, wantToKnowLine2, howToMeasure },
    },
  } = useTranslation()
  const { columnNames, columnValues, imageUri, tips, tables } = sizeChart ?? {}
  return (
    <>
      {tables?.length ? (
        <SizeChartModalTable {...{ initialActiveTab, onClose, showHeader, sizeChart }} />
      ) : (
        <>
          {showHeader && (
            <Header>
              <HeaderText textType='h2' textTransform='uppercase' textAlign='center'>
                {headline}
              </HeaderText>
              <CloseButton
                onClick={onClose}
                {...trackEvent({ category: 'product details', action: 'close size chart modal' })}
              />
            </Header>
          )}
          <Content>
            <WantToKnowText>
              {wantToKnowLine1}
              <br />
              {wantToKnowLine2}
            </WantToKnowText>
            <TableWrapper>
              {columnNames && columnValues ? (
                <Table>
                  <thead>
                    <Tr>
                      {columnNames.map((column, index) => (
                        <Th key={`${column}-${index}`}>{column}</Th>
                      ))}
                    </Tr>
                  </thead>
                  <tbody>
                    {columnValues.map((values, index) => (
                      <Tr key={`${values[0]}-${index}`}>
                        {values.map((value, valueIndex) => (
                          <Td key={`${value}-${valueIndex}`}>{value}</Td>
                        ))}
                      </Tr>
                    ))}
                  </tbody>
                </Table>
              ) : null}
            </TableWrapper>
            {tips && tips?.length > 0 ? (
              <TipsSection>
                <TipsSectionContent>
                  <TipsSectionTextBlock>
                    <HowToMeasureText>{howToMeasure}</HowToMeasureText>
                    <ul>
                      {tips.map((item, index) => (
                        <TipItem key={`${item.kind}-${index}`}>
                          <TipCheckMark>
                            <CheckMark />
                          </TipCheckMark>
                          <b>{item.kind}</b>. {item.tip}
                        </TipItem>
                      ))}
                    </ul>
                  </TipsSectionTextBlock>
                  {imageUri && (
                    <ResponsiveImage
                      alt={'size chart tip image'}
                      src={imageUri}
                      aspectRatios={{
                        sm: null,
                        md: null,
                      }}
                      widths={{ unit: 'vw', sm: 100, md: 40 }}
                      loading='default'
                    />
                  )}
                </TipsSectionContent>
              </TipsSection>
            ) : null}
          </Content>
        </>
      )}
    </>
  )
}
